/**
 * WGS84 → S-JTSK (EPSG:5514) pro export RD (ukončení před RD souřasnice_X/Y).
 * Stejná definice jako PostGIS transformace v object-spatial.service.
 */

import proj4 from 'proj4';

proj4.defs(
  'EPSG:5514',
  '+proj=krovak +lat_0=49.5 +lon_0=24.833333333333334 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs',
);

export interface SjtskCoordinates {
  /** Souřadnice X (ST_X po transformaci do 5514). */
  x: number;
  /** Souřadnice Y (ST_Y po transformaci do 5514). */
  y: number;
}

export function wgs84LngLatToSjtsk(lng: number, lat: number): SjtskCoordinates | null {
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;
  try {
    const [x, y] = proj4('EPSG:4326', 'EPSG:5514', [lng, lat]) as [number, number];
    if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
    return { x, y };
  } catch {
    return null;
  }
}

/** S-JTSK (EPSG:5514) → WGS84 lng/lat — náhled importovaných vrstev na OSM. */
export function sjtskToWgs84LngLat(x: number, y: number): { lng: number; lat: number } | null {
  if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
  try {
    const [lng, lat] = proj4('EPSG:5514', 'EPSG:4326', [x, y]) as [number, number];
    if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;
    if (Math.abs(lng) > 180 || Math.abs(lat) > 90) return null;
    return { lng, lat };
  } catch {
    return null;
  }
}

/** Zaokrouhlení na 2 desetinná místa (shodně s geoJsonPrecision na BE). */
export function formatSjtskCoord(value: number): string {
  return String(Math.round(value * 100) / 100);
}
